<template>
    <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
        <li class="m-menu__section">
            <h4 class="m-menu__section-text">
                MAIN MENU
            </h4>
            <i class="m-menu__section-icon flaticon-more-v3"></i>
        </li>
        <li class="m-menu__item  m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover">
            <router-link :to="{ name: 'services' }" class="m-menu__link m-menu__toggle">
                <i class="m-menu__link-icon fa fa-dashboard"></i>
                <span class="m-menu__link-text">
                    Dashboard
                </span>
            </router-link>
        </li>
        <li class="m-menu__item  m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover">
            <router-link :to="{ name: 'billing' }" class="m-menu__link m-menu__toggle">
                <i class="m-menu__link-icon fa fa-credit-card"></i>
                <span class="m-menu__link-text">
                    Billing
                </span>
            </router-link>
        </li>
        <li class="m-menu__item  m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover">
            <router-link :to="{ name: 'about' }" class="m-menu__link m-menu__toggle">
                <i class="m-menu__link-icon fa fa-info-circle"></i>
                <span class="m-menu__link-text">
                    About ZIZI
                </span>
            </router-link>
        </li>
        <li class="m-menu__item  m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover">
            <router-link :to="{ name: 'terms' }" class="m-menu__link m-menu__toggle">
                <i class="m-menu__link-icon fa fa-check-circle"></i>
                <span class="m-menu__link-text">
                    Terms & Conditions
                </span>
            </router-link>
        </li>
    </ul>
</template>
<<script>
export default {
  name: 'dashboardnav'
}
</script>




// WEBPACK FOOTER //
// src/components/partials/DashboardNav.vue